module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single-page"
  }, [_c('keep-alive', [_c('router-view', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.inputDataLoading),
      expression: "inputDataLoading"
    }]
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-map",
    class: {
      'hide-map': ['/home/single', '/single_home/single'].indexOf(_vm.path) === -1
    }
  }, [_c('chart_map_pre')], 1), _vm._v(" "), _c('switch_map_btn', {
    attrs: {
      "mapPathName": _vm.path.indexOf('/home/single') > -1 ? 'single' : 'single.single'
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32b8ebff","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/oil/single.vue
// module id = 970
// module chunks = 1